module.exports = __webpack_public_path__ + "static/media/close.577b65a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.svg
// module id = 542
// module chunks = 0